import { useState, useEffect } from "react";
import "../styles/MainIntro.css";

export default function MainIntro() {
  const [introImage, setIntroImage] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchImage = async () => {
      setLoading(true);
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/images/main`,
        );

        if (!res.ok) {
          throw new Error(res.message || "Failed to fetch image");
        }

        const data = await res.json();

        setIntroImage(data.data.intro);
      } catch (err) {
        setError(err.message || "Failed to fetch image");
      } finally {
        setLoading(false);
      }
    };
    fetchImage();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Unable to load images.</div>;
  }

  if (!introImage || introImage.length < 1) {
    return <div>Loading image...</div>;
  }

  return (
    <div className="intro__container">
      <section className="intro__picnic--container">
        <div className="intro__picnic--image-container">
          <img
            className="intro__picnic--image-beach"
            src={introImage[0].src}
            alt={introImage[0].alt}
            onContextMenu={(e) => e.preventDefault()}
            draggable="false"
          />
        </div>
        <div className="intro__picnic--content">
          <h2>A Luxury Picnic Experience on Beautiful Bribie Island</h2>
          <p>
            Experience a luxurious picnic on the fourth largest sand island in
            the world, accessible by bridge. Located within the renowned Moreton
            Bay Marine Park, a vital habitat for birds and marine life, this
            stunning destination boasts pristine white sandy beaches and calm
            waters. Enjoy spectacular views of the Pumicestone passage and the
            glass house mountains, creating the perfect setting for a tranquil
            and unforgettable day on the island.
          </p>
          <p>
            Offering luxury picnics, tablescapes and event styling for every
            occasion - whether its an anniversary, proposal, birthday, baby
            shower, or any special life event worth celebrating. We help take
            care of all the details to create a beautiful picnic or event for
            you and your loved ones. Our goal is to ensure you can truly enjoy
            the moment, while we handle the rest. We would love to be a part of
            your celebration.
          </p>
        </div>
      </section>
    </div>
  );
}
